<template>
    <div>
        <v-app-bar elevation="0" clipped-left style="background-color: #161616">
            <div class="novecento" style="color: white; cursor: pointer">California Fish & Wildlife - Dashboard</div>
        </v-app-bar>
        <v-tabs v-model="currentTab" background-color="#464646" class="top-tabs" dark slider-color="getac" show-arrows>
            <v-tab v-for="(tab, index) in tabs" :key="index" exact>{{ tab.title }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="currentTab">
            <v-progress-linear v-if="loading" indeterminate color="#db5120"></v-progress-linear>
            <v-tab-item :key="0">
                <v-card flat>
                    <prtg></prtg>
                </v-card>
            </v-tab-item>
            <v-tab-item :key="1">
                <v-card flat>
                    <call-logs></call-logs>
                </v-card>
            </v-tab-item>
            <v-tab-item :key="2">
                <v-card flat>
                    <rmas @loading="loading = $event"></rmas>
                </v-card>
            </v-tab-item>
            <v-tab-item :key="3">
                <v-card flat>
                    <happyfox-cases @loading="loading = $event"></happyfox-cases>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
        <div> </div>
    </div>
</template>

<script>
import HappyfoxCases from './happyfox_cases/index.vue'
import Rmas from './rmas/index.vue'
import Prtg from './prtg_report/index.vue'
import CallLogs from './call_logs/index.vue'

export default {
    metaInfo: { title: `Your Account`, subTitle: `Dashboard` },
    name: `CdfwDashboard`,
    components: { HappyfoxCases, Rmas, Prtg, CallLogs },
    data() {
        return {
            loading: false,
            currentTab: 0,
            tabs: [
                {
                    title: `PRTG Reports`,
                    name: ``
                },
                {
                    title: `Call Logs`,
                    name: ``
                },

                {
                    title: `RMA/Advanced Exchange Info`,
                    name: ``
                },
                {
                    title: `HappyFox Cases`,
                    name: ``
                }
            ]
        }
    },
    computed: {},
    methods: {}
}
</script>
